const levels = [
    {
        id: 1,
        description: "Nivell 1"
    },
    {
        id: 2,
        description: "Nivell 2"
    },
    {
        id: 3,
        description: "Nivell 3"
    }
]

export { levels }


// WEBPACK FOOTER //
// ./src/services/level.service.js